import React, { useState, useEffect } from 'react';
import { Segment } from './index';
import { userData } from 'util/userData';

interface AddSegmentModalProps {
  isOpen: boolean;
  toggle: () => void;
  addSegment: (rowData: Segment) => void;
}

const AddSegmentModal: React.FC<AddSegmentModalProps> = ({ isOpen, toggle, addSegment }) => {
  const [formData, setFormData] = useState<Partial<Segment>>({
    customer: userData.getCurrentProject(),
  });
  const [formError, setFormError] = useState<string | null>(null);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    const requiredFields = ['customer', 'filecolumnname', 'segmentavid', 'segmentname', 'segmentvalueavid', 'segmentvaluename', 'startvalue', 'include_in_deck'];
    for (const field of requiredFields) {
      if (!formData[field]) {
        setFormError(`Field "${field}" is required.`);
        return;
      }
    }
    addSegment(formData as Segment);
    toggle();
  };

  useEffect(() => {
    const modalElement = document.querySelector('.modal') as HTMLElement;
    if (modalElement) {
      // Open or close the modal based on the `isOpen` prop
      if (isOpen) {
        modalElement.classList.add('open');
        modalElement.style.display = 'block';
      } else {
        modalElement.classList.remove('open');
        modalElement.style.display = 'none';
      }
    }
  }, [isOpen]);

  return (
    <div className={`modal ${isOpen ? 'open' : ''} add-segment-modal`} style={{ display: isOpen ? 'block' : 'none', overflow: 'scroll' }}>
      <div className="modal-content">
        <h4>Add New Segment</h4>
        {formError && <div className="card-panel red lighten-4">{formError}</div>}

        <div className="row">
          <div className="input-field col s6">
            <input id="customer" name="customer" type="text" value={formData.customer || ''} onChange={handleInputChange} />
            <label htmlFor="customer">Customer</label>
          </div>
          <div className="input-field col s6">
            <input id="filecolumnname" name="filecolumnname" type="text" onChange={handleInputChange} />
            <label htmlFor="filecolumnname">File Column Name</label>
          </div>
        </div>

        <div className="row">
          <div className="input-field col s4">
            <input id="segmentavid" name="segmentavid" type="text" onChange={handleInputChange} />
            <label htmlFor="segmentavid">Segment Avid</label>
          </div>
          <div className="input-field col s4">
            <input id="segmentname" name="segmentname" type="text" onChange={handleInputChange} />
            <label htmlFor="segmentname">Segment Name</label>
          </div>
          <div className="input-field col s4">
            <input id="segmentvalueavid" name="segmentvalueavid" type="text" onChange={handleInputChange} />
            <label htmlFor="segmentvalueavid">Segment Value Avid</label>
          </div>
        </div>

        <div className="row">
          <div className="input-field col s4">
            <input id="segmentvaluename" name="segmentvaluename" type="text" onChange={handleInputChange} />
            <label htmlFor="segmentvaluename">Segment Value Name</label>
          </div>
          <div className="input-field col s4">
            <input id="startvalue" name="startvalue" type="text" onChange={handleInputChange} />
            <label htmlFor="startvalue">Start Value</label>
          </div>
          <div className="input-field col s4">
            <input id="include_in_deck" name="include_in_deck" type="number" onChange={handleInputChange} />
            <label htmlFor="include_in_deck">Include in Deck</label>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn waves-effect waves-light" onClick={handleSubmit}>
          Add Segment
        </button>
        <button className="btn-flat btn-secondary" onClick={toggle}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddSegmentModal;